<div class="loader">
  <span class="dot"></span>
  <span class="dot"></span>
  <span class="dot"></span>
</div>
